/**
 * Cards module state — intent and style card selection.
 * Decoupled from the main creation state in core/store.js.
 *
 * Intent card: single-select (the generation "mode")
 * Style cards: multiple selections (style modifiers)
 */

/** Categories toggled ON by default in the inspiration workspace. LOWERCASE —
 *  card.category arrives mixed-case (bundle cards Title-case 'Color', vision/
 *  reference cards lowercase 'color'); all comparisons normalize to lowercase so
 *  the two never miss each other. why → Zeus click-path F3 root-cause 2026-06-21. */
export const DEFAULT_ON = new Set(['color', 'lighting'])

export const cardsState = {
  intent: {
    /** @type {import('./api.js').Card[]} */
    cards: [],
    loading: false,
    loaded: false,
  },
  style: {
    /** @type {import('./api.js').Card[]} */
    cards: [],
    /**
     * Visible categories based on selected intent card.
     * null = show all categories.
     * @type {string[] | null}
     */
    visibleCategories: null,
  },
}
